import { render, staticRenderFns } from "./CalendarEdit.vue?vue&type=template&id=24f908d0&"
import script from "./CalendarEdit.vue?vue&type=script&lang=js&"
export * from "./CalendarEdit.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports